<template>
  <main class="start-teaching">
    <section>
      <BaseBreadcrumb
        v-if="getBreadcrumb"
        class="container my-4"
        :breadcrumb="getBreadcrumb"
      />
      <StartTeachingTopBanner />
    </section>
    <StartTeachingAdvantages />
    <StartTeachingTutorTestimonial @signup="signupHandle" />
    <!--
    <SectionStatistics v-if="hasStatistics" background="bg-purple" />
-->
    <StartTeachingTopTutors @signup="signupHandle" />
    <StartTeachingCurvePrice />
    <StartTeachingHowBecomeTutor @signup="signupHandle" />
    <section class="container">
      <SectionFAQs v-if="hasFAQS" class="w-full lg:w-10/12 mx-auto" />
    </section>
    <!--    <StartTeachingArticles class="mb-20 lg:mb-[120px]" />-->
    <StartTeachingAboutUs @signup="signupHandle" />
    <SectionSeoContent />
    <!--
    <SectionSeoContentInternalLinks v-if="hasInternalLinks" class="mt-7" />
-->
    <StartTeachingSignupBanner
      @signup="signupHandle"
    />
  </main>
</template>

<script>
import SectionFAQs from '@design-system/section/faqs/faqs'
/*
import SectionStatistics from '@design-system/section/statistics/statistics'
*/
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb-pages'
import { mapGetters } from 'vuex'
import { renderHead } from '@helper/head/head-home'
import { hydrateWhenVisible } from 'vue-lazy-hydration'
// import SectionSeoContentInternalLinks from '@design-system/section/seo-content/seo-content-internal-links'
import { isEmpty } from 'lodash'
import SectionSeoContent from '@design-system/section/seo-content/seo-content'
import StartTeachingTopBanner from '~/components/pages/start-teaching/top-banner/top-banner.vue'
import StartTeachingAdvantages from '~/components/pages/start-teaching/advantages/advantages.vue'
import StartTeachingHowBecomeTutor from '~/components/pages/start-teaching/how-become-tutor/how-become-tutor.vue'
import StartTeachingAboutUs from '~/components/pages/start-teaching/about-us/about-us.vue'
// import StartTeachingStartTutoring from '~/components/pages/start-teaching/start-tutoring/start-tutoring.vue'
import StartTeachingCurvePrice from '~/components/pages/start-teaching/curve-price/curve-price.vue'
// import StartTeachingArticles from '~/components/pages/start-teaching/articles/articles.vue'
import StartTeachingSignupBanner from '~/components/pages/start-teaching/signup-banner/signup-banner.vue'
export default ({
  name: 'StartTeaching',
  auth: false,
  components: {
    StartTeachingTopBanner,
    StartTeachingAdvantages,
    StartTeachingHowBecomeTutor,
    StartTeachingAboutUs,
    StartTeachingSignupBanner,
    BaseBreadcrumb,
    StartTeachingCurvePrice,
    SectionSeoContent,
    // StartTeachingArticles,
    StartTeachingTopTutors: hydrateWhenVisible(
      () => import('~/components/pages/start-teaching/top-tutors/top-tutors-list.vue'),
      { observerOptions: { rootMargin: '100px' } }
    ),
    /*
    SectionStatistics,
*/
    StartTeachingTutorTestimonial: hydrateWhenVisible(
      () => import('~/components/pages/start-teaching/tutor-testimonial/tutor-testimonial'),
      { observerOptions: { rootMargin: '100px' } }
    ),
    SectionFAQs
  },
  layout: 'main',
  async asyncData ({ store }) {
    await store.dispatch('local/asyncDataLanding')
  },
  data () {
    return {
      showMe: false
    }
  },
  head () {
    return renderHead({ meta: this.getMeta })
  },
  computed: {
    ...mapGetters('global', ['getMeta', 'getStatistics', 'getFaqs', 'getInternalLinks', 'getBreadcrumb']),
    ...mapGetters('local', ['getStepStatus', 'getRouteNameSteps']),
    hasStatistics () {
      return !isEmpty(this.getStatistics)
    },
    hasFAQS () {
      return !isEmpty(this.getFaqs)
    },
    hasInternalLinks () {
      return !isEmpty(this.getInternalLinks)
    }
  },
  methods: {
    signupHandle () {
      if (this.getStepStatus) {
        this.$router.push(this.localePath(this.getRouteNameSteps[this.getStepStatus]))
      } else {
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })
      }
    }
  }
})
</script>

<style lang="scss">
.start-teaching {
  @apply space-y-20 lg:space-y-[160px];
}
</style>
